import { jsx as _jsx } from "react/jsx-runtime";
import icon from './expandArrowRight.svg';
export const ExpandArrowRightSvgComponent = () => (_jsx("svg", { width: '11', height: '16', viewBox: '0 0 11 16', fill: 'none', xmlns: 'http://www.w3.org/2000/svg', children: _jsx("path", { d: 'M0.953125 2.04508L6.86313 7.95508L0.953125 13.8651L2.54313 15.4551L10.0431 7.95508L2.54313 0.455078L0.953125 2.04508Z', fill: '#828282' }) }));
export default icon;
